export const CENTURIES = 'CENTURIES';
export const DAYS = 'DAYS';
export const DECADES = 'DECADES';
export const ERAS = 'ERAS';
export const FOREVER = 'FOREVER';
export const HALF_DAYS = 'HALF_DAYS';
export const HOURS = 'HOURS';
export const MICROS = 'MICROS';
export const MILLENNIA = 'MILLENNIA';
export const MILLIS = 'MILLIS';
export const MINUTES = 'MINUTES';
export const MONTHS = 'MONTHS';
export const NANOS = 'NANOS';
export const SECONDS = 'SECONDS';
export const WEEKS = 'WEEKS';
export const YEARS = 'YEARS';